var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _ApiFetch_url, _ApiFetch_method, _ApiFetch_authString, _ApiFetch_headers, _ApiFetch_body, _ApiFetch_config;
import camelcaseKeys from 'camelcase-keys';
import { Result } from 'monadix/result';
import { errorFromResponse } from '../connection/api-connection-error.js';
;
export const defaultListing = {
    skip: 0,
    count: 2147483647,
};
export const API_BASE = '/XAPI/v2';
export const getVersionMatch = (response, beeyVersion) => {
    if (!response.headers.has('beey-version')) {
        return 'unknown';
    }
    if (response.headers.get('beey-version') === beeyVersion) {
        return 'perfect';
    }
    // NOTE: API v2 is not guaranteed to be backwards compatible,
    // so we force refresh. API v1 is backwards compatible, so we only
    // recommend refresh.
    return response.url.includes('API/v2') ? 'incompatible' : 'compatible';
};
const camelcaseResult = (json, camelcaseResponse) => {
    if (camelcaseResponse) {
        return camelcaseKeys(json, {
            deep: true,
            // NOTE: prevents camelcasing language codes such as cs-CZ
            exclude: [/.*-.*/],
        });
    }
    if ('Errors' in json) {
        return {
            errors: json.Errors,
            data: json.Data,
        };
    }
    return { data: json.Data };
};
const camelcaseServiceResult = (json, camelcaseResponse) => {
    if (camelcaseResponse) {
        return camelcaseKeys(json, {
            deep: true,
            // NOTE: prevents camelcasing language codes such as cs-CZ
            exclude: [/.*-.*/],
        });
    }
    return json;
};
export const extractJsonData = async (response, camelcaseResponse, endpointType) => {
    const json = await response.json();
    if (endpointType === 'beey') {
        const result = camelcaseResult(json, camelcaseResponse);
        if ('errors' in result) {
            throw new Error(result.errors[0].message);
        }
        return result.data;
    }
    return camelcaseServiceResult(json, camelcaseResponse);
};
export class ApiFetch {
    constructor(beeyVersion, url, method, authString, headers, body, config, interceptFn, extractFn) {
        _ApiFetch_url.set(this, void 0);
        _ApiFetch_method.set(this, void 0);
        _ApiFetch_authString.set(this, void 0);
        _ApiFetch_headers.set(this, {});
        _ApiFetch_body.set(this, void 0);
        _ApiFetch_config.set(this, void 0);
        this.beeyVersion = beeyVersion;
        __classPrivateFieldSet(this, _ApiFetch_url, url, "f");
        __classPrivateFieldSet(this, _ApiFetch_method, method, "f");
        __classPrivateFieldSet(this, _ApiFetch_authString, authString, "f");
        __classPrivateFieldSet(this, _ApiFetch_headers, headers, "f");
        __classPrivateFieldSet(this, _ApiFetch_body, body, "f");
        __classPrivateFieldSet(this, _ApiFetch_config, config, "f");
        this.interceptFn = interceptFn;
        this.extractFn = extractFn;
    }
    static create() {
        return new ApiFetch(null, '/API', 'GET', null, {}, undefined, {
            throwOnHttpError: false,
            camelcaseResponse: true,
            endpointType: 'beey',
        }, (response) => Result.success(response), async (response) => response);
    }
    url(url) {
        return new ApiFetch(this.beeyVersion, url, __classPrivateFieldGet(this, _ApiFetch_method, "f"), __classPrivateFieldGet(this, _ApiFetch_authString, "f"), __classPrivateFieldGet(this, _ApiFetch_headers, "f"), __classPrivateFieldGet(this, _ApiFetch_body, "f"), __classPrivateFieldGet(this, _ApiFetch_config, "f"), this.interceptFn, this.extractFn);
    }
    method(method) {
        return new ApiFetch(this.beeyVersion, __classPrivateFieldGet(this, _ApiFetch_url, "f"), method, __classPrivateFieldGet(this, _ApiFetch_authString, "f"), __classPrivateFieldGet(this, _ApiFetch_headers, "f"), __classPrivateFieldGet(this, _ApiFetch_body, "f"), __classPrivateFieldGet(this, _ApiFetch_config, "f"), this.interceptFn, this.extractFn);
    }
    version(version) {
        return new ApiFetch(version, __classPrivateFieldGet(this, _ApiFetch_url, "f"), __classPrivateFieldGet(this, _ApiFetch_method, "f"), __classPrivateFieldGet(this, _ApiFetch_authString, "f"), __classPrivateFieldGet(this, _ApiFetch_headers, "f"), __classPrivateFieldGet(this, _ApiFetch_body, "f"), __classPrivateFieldGet(this, _ApiFetch_config, "f"), this.interceptFn, this.extractFn);
    }
    config(config) {
        return new ApiFetch(this.beeyVersion, __classPrivateFieldGet(this, _ApiFetch_url, "f"), __classPrivateFieldGet(this, _ApiFetch_method, "f"), __classPrivateFieldGet(this, _ApiFetch_authString, "f"), __classPrivateFieldGet(this, _ApiFetch_headers, "f"), __classPrivateFieldGet(this, _ApiFetch_body, "f"), Object.assign(Object.assign({}, __classPrivateFieldGet(this, _ApiFetch_config, "f")), config), this.interceptFn, this.extractFn);
    }
    get() {
        return this.method('GET');
    }
    post(body) {
        return this.method('POST').body(body);
    }
    postJson(body) {
        return this.header('Content-Type', 'application/json').post(JSON.stringify(body));
    }
    postText(body) {
        return this.header('Content-Type', 'text/plain').post(body);
    }
    postBlob(body) {
        return this.header('Content-Type', 'application/octet-stream').post(body);
    }
    postFormData(body) {
        return this.header('Content-Type', 'multipart/form-data').post(body);
    }
    put(body) {
        return this.method('PUT').body(body);
    }
    putJson(body) {
        return this.header('Content-Type', 'application/json').put(JSON.stringify(body));
    }
    patch(body) {
        return this.method('PATCH').body(body);
    }
    patchJson(body) {
        return this.header('Content-Type', 'application/json').patch(JSON.stringify(body));
    }
    delete() {
        return this.method('DELETE');
    }
    deleteJson(body) {
        return this.header('Content-Type', 'application/json').delete().body(JSON.stringify(body));
    }
    auth(authString) {
        return new ApiFetch(this.beeyVersion, __classPrivateFieldGet(this, _ApiFetch_url, "f"), __classPrivateFieldGet(this, _ApiFetch_method, "f"), authString, __classPrivateFieldGet(this, _ApiFetch_headers, "f"), __classPrivateFieldGet(this, _ApiFetch_body, "f"), __classPrivateFieldGet(this, _ApiFetch_config, "f"), this.interceptFn, this.extractFn);
    }
    ;
    header(key, value) {
        return new ApiFetch(this.beeyVersion, __classPrivateFieldGet(this, _ApiFetch_url, "f"), __classPrivateFieldGet(this, _ApiFetch_method, "f"), __classPrivateFieldGet(this, _ApiFetch_authString, "f"), Object.assign(Object.assign({}, __classPrivateFieldGet(this, _ApiFetch_headers, "f")), { [key]: value }), __classPrivateFieldGet(this, _ApiFetch_body, "f"), __classPrivateFieldGet(this, _ApiFetch_config, "f"), this.interceptFn, this.extractFn);
    }
    headers(headers) {
        return new ApiFetch(this.beeyVersion, __classPrivateFieldGet(this, _ApiFetch_url, "f"), __classPrivateFieldGet(this, _ApiFetch_method, "f"), __classPrivateFieldGet(this, _ApiFetch_authString, "f"), Object.assign(Object.assign({}, __classPrivateFieldGet(this, _ApiFetch_headers, "f")), headers), __classPrivateFieldGet(this, _ApiFetch_body, "f"), __classPrivateFieldGet(this, _ApiFetch_config, "f"), this.interceptFn, this.extractFn);
    }
    body(body) {
        return new ApiFetch(this.beeyVersion, __classPrivateFieldGet(this, _ApiFetch_url, "f"), __classPrivateFieldGet(this, _ApiFetch_method, "f"), __classPrivateFieldGet(this, _ApiFetch_authString, "f"), __classPrivateFieldGet(this, _ApiFetch_headers, "f"), body, __classPrivateFieldGet(this, _ApiFetch_config, "f"), this.interceptFn, this.extractFn);
    }
    intercept(interceptFn) {
        return new ApiFetch(this.beeyVersion, __classPrivateFieldGet(this, _ApiFetch_url, "f"), __classPrivateFieldGet(this, _ApiFetch_method, "f"), __classPrivateFieldGet(this, _ApiFetch_authString, "f"), __classPrivateFieldGet(this, _ApiFetch_headers, "f"), __classPrivateFieldGet(this, _ApiFetch_body, "f"), __classPrivateFieldGet(this, _ApiFetch_config, "f"), interceptFn, this.extractFn);
    }
    async bareFetch() {
        const response = await fetch(__classPrivateFieldGet(this, _ApiFetch_url, "f"), {
            method: __classPrivateFieldGet(this, _ApiFetch_method, "f"),
            cache: 'no-cache',
            headers: Object.assign(Object.assign({}, __classPrivateFieldGet(this, _ApiFetch_headers, "f")), { Authorization: __classPrivateFieldGet(this, _ApiFetch_authString, "f") === null
                    ? ''
                    : typeof __classPrivateFieldGet(this, _ApiFetch_authString, "f") === 'string'
                        ? __classPrivateFieldGet(this, _ApiFetch_authString, "f")
                        : await __classPrivateFieldGet(this, _ApiFetch_authString, "f").call(this) }),
            body: __classPrivateFieldGet(this, _ApiFetch_body, "f"),
        });
        const apiResponse = this.beeyVersion === null
            ? Object.assign(response, {
                method: __classPrivateFieldGet(this, _ApiFetch_method, "f"), versionMatch: 'unknown'
            })
            : Object.assign(response, {
                method: __classPrivateFieldGet(this, _ApiFetch_method, "f"), versionMatch: getVersionMatch(response, this.beeyVersion)
            });
        const result = await this.interceptFn(apiResponse);
        if (result.isFail()) {
            return result;
        }
        if (!result.get().ok && __classPrivateFieldGet(this, _ApiFetch_config, "f").throwOnHttpError) {
            throw await errorFromResponse(apiResponse);
        }
        return result;
    }
    async fetchResult() {
        const result = await this.bareFetch();
        if (result.isFail()) {
            return result;
        }
        return Result.success(await this.extractFn(result.get()));
    }
    async fetch() {
        const result = await this.fetchResult();
        return result.isSuccess() ? result.get() : result.err();
    }
    async send() {
        await this.bareFetch();
    }
    json(mapFn) {
        return new ApiFetch(this.beeyVersion, __classPrivateFieldGet(this, _ApiFetch_url, "f"), __classPrivateFieldGet(this, _ApiFetch_method, "f"), __classPrivateFieldGet(this, _ApiFetch_authString, "f"), __classPrivateFieldGet(this, _ApiFetch_headers, "f"), __classPrivateFieldGet(this, _ApiFetch_body, "f"), __classPrivateFieldGet(this, _ApiFetch_config, "f"), this.interceptFn, async (response) => {
            const data = await extractJsonData(response, __classPrivateFieldGet(this, _ApiFetch_config, "f").camelcaseResponse, __classPrivateFieldGet(this, _ApiFetch_config, "f").endpointType);
            return mapFn ? mapFn(data) : data;
        });
    }
    text() {
        return new ApiFetch(this.beeyVersion, __classPrivateFieldGet(this, _ApiFetch_url, "f"), __classPrivateFieldGet(this, _ApiFetch_method, "f"), __classPrivateFieldGet(this, _ApiFetch_authString, "f"), __classPrivateFieldGet(this, _ApiFetch_headers, "f"), __classPrivateFieldGet(this, _ApiFetch_body, "f"), __classPrivateFieldGet(this, _ApiFetch_config, "f"), this.interceptFn, async (response) => response.text());
    }
    blob() {
        return new ApiFetch(this.beeyVersion, __classPrivateFieldGet(this, _ApiFetch_url, "f"), __classPrivateFieldGet(this, _ApiFetch_method, "f"), __classPrivateFieldGet(this, _ApiFetch_authString, "f"), __classPrivateFieldGet(this, _ApiFetch_headers, "f"), __classPrivateFieldGet(this, _ApiFetch_body, "f"), __classPrivateFieldGet(this, _ApiFetch_config, "f"), this.interceptFn, async (response) => response.blob());
    }
    buffer() {
        return new ApiFetch(this.beeyVersion, __classPrivateFieldGet(this, _ApiFetch_url, "f"), __classPrivateFieldGet(this, _ApiFetch_method, "f"), __classPrivateFieldGet(this, _ApiFetch_authString, "f"), __classPrivateFieldGet(this, _ApiFetch_headers, "f"), __classPrivateFieldGet(this, _ApiFetch_body, "f"), __classPrivateFieldGet(this, _ApiFetch_config, "f"), this.interceptFn, async (response) => response.arrayBuffer());
    }
}
_ApiFetch_url = new WeakMap(), _ApiFetch_method = new WeakMap(), _ApiFetch_authString = new WeakMap(), _ApiFetch_headers = new WeakMap(), _ApiFetch_body = new WeakMap(), _ApiFetch_config = new WeakMap();
export const apiFetch = () => ApiFetch.create();
